import type { AttachmentMeta, DraftDocument, ScopeApi } from "@procurement-agents/scope-api";

/** PLAN_venueswest E follow-up: a document added to the draft is read by a worker; a chat turn that names it waits
 *  until it has been. Resolves with the document as read (extracted_ok false when it could not be). */
export async function waitUntilRead(api: ScopeApi, runId: string, attachmentId: string, { every = 700, timeout = 90_000 } = {}): Promise<DraftDocument> {
  const until = Date.now() + timeout;
  for (;;) {
    const run = await api.getRun(runId);
    const doc = ("documents" in run ? run.documents ?? [] : []).find((d) => d.attachment_id === attachmentId);
    if (doc && !doc.extracting) return doc;
    if (Date.now() > until) throw new Error("the document is taking too long to read; try sending again in a moment");
    await new Promise((r) => setTimeout(r, every));
  }
}

/** A read document in the shape the attachment chips show. */
export const asAttachment = (d: DraftDocument): AttachmentMeta => ({
  attachment_id: d.attachment_id, name: d.name, size: d.size, content_type: "", text_chars: d.text_chars ?? 0, truncated: false,
  extracted_ok: !!d.extracted_ok, note: d.extracted_ok ? null : d.note ?? "no readable text",
} as AttachmentMeta);
